(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/customized-feedback-handler/assets/javascripts/handler.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/customized-feedback-handler/assets/javascripts/handler.js');
"use strict";


const ErrorCode = svs.oddset_kambi.components.customizedFeedbackHandler.constants.ErrorCode;
const accountBalanceComponent = svs.components.account_balance;
const _svs$oddset_kambi$com = svs.oddset_kambi.components.wapiIntegration,
  hideBetslip = _svs$oddset_kambi$com.hideBetslip,
  showBetslip = _svs$oddset_kambi$com.showBetslip;
const _svs$components$oddse = svs.components.oddset.clientErrorHandler.errorDialogs,
  checkRestricitions = _svs$components$oddse.checkRestricitions,
  displayGenericErrorDialog = _svs$components$oddse.displayGenericErrorDialog,
  onInsufficientFunds = _svs$components$oddse.onInsufficientFunds,
  onLimitExceeded = _svs$components$oddse.onLimitExceeded,
  onOddsChanged = _svs$components$oddse.onOddsChanged;
const logger = svs.core.log.getLogger('oddset_kambi:components:customizedFeedbackHandler');
const handleCustomizedFeedback = event => {
  hideBetslip();
  switch (event.feedback.type) {
    case ErrorCode.TECHNICAL_ERROR:
      accountBalanceComponent.get(true, balance => {
        if (parseInt(balance, 10) === 0) {
          onInsufficientFunds(showBetslip);
        } else {
          checkRestricitions(showBetslip);
        }
      });
      break;
    case ErrorCode.NOT_ENOUGH_FUNDS:
      onInsufficientFunds(showBetslip);
      break;
    case ErrorCode.RESPONSIBLE_GAMING_LIMIT_EXCEEDED:
      onLimitExceeded(showBetslip);
      break;
    case ErrorCode.ODDS_CHANGED:
      onOddsChanged(showBetslip);
      break;
    default:
      logger.warn('Oddset generic error: unhandled customizedFeedback');
      displayGenericErrorDialog(showBetslip);
      break;
  }
};
setGlobal('svs.oddset_kambi.components.customizedFeedbackHandler.handleCustomizedFeedback', handleCustomizedFeedback);

 })(window);